import config from '@storage'
import {PAYMENT_GATEWAY, TOKEN} from "../const/servicesPath"

export const basicInfo = {
    companyName: 'Amrak Institute of Medical Sciences',
    address: 'N0, 5 Alfred Pl, Colombo 00300,',
    country: 'Sri Lanka.',
    contact: '(+94)11 2140 222',
    mailTo: 'info@amrak.lk',

    paymentPlanLevel: true,
    allowStudentMultiplePayment: false,
    roleRestrictionInUserCreation: false,

    regCode: 'SID',
    regText: 'Student ID',
    inqCode: 'INQ',

    //Currently Department for CINEC and School for other university
    schoolLabel: 'School',
    schoolKey: 'school',

    //Currently Program for CINEC and Course for other university
    courseLabel: 'Course',
    courseKey: 'course',
    courseId: 'courseId',

    //Currently Program Identifier for CINEC and Program Code for other university
    programCode: 'Program Code'
}

export const commonConfig = {
    MAXIMUM_ROWS_PER_EXPORT: 1000
}

export const paymentGatewayUrlInfo = {

    // for apiit
    // paymentUrl: `${PAYMENT_GATEWAY}/hnb-cybersource/${TOKEN}`,

    // for other
    paymentUrl: 'payment-gateway',

    // IJSE,APIIT,UNICLOUD,AMRAC
    gatewayType: 'AMRAC'
}

export const accessList = {
    // amrak allow list
    allowDiscountRequest: true,

    // restricted all project manage feature in all roles
    allowStudentProjects: false,

    // restricted all special approval process in all roles
    allowSpecialApproval: false,

    // restricted only attendance url and qr generating feature
    allowAttendanceMarkWithUrlAndQr: false,

    // restricted all target management feature in all roles
    allowTargetManagement: false,

    allowStudentExit: false,

    //this directly haa can drop the student, doesn't restrict the drop fully
    allowStudentDrop: false,

    // this is only true for apiit
    allowStudentDropToLibrarian: true,

    // this is only true for apiit
    allowStudentDropMailToHaaByMaa: true,

    //fully hide progression process in system
    allowProgressionProcess: true,
    //progression mannualy in only  haa role
    //Only haa can do the progression. Only details are shown to the student.
    //If you want the full package, you need to set allowProgressionProcess : true and set this to true.
    allowFullAccessProgression: false,
    allowExtraClasses: false,
    allowRescheduleClasses: true,
    allowRescheduleClassesAddRow: false,

    //This allows the exam schedule edit button and student section and venue sections,
    //exam schedule expandableRows,
    //student side table venue and time duration column in  assessmentTimetable
    allowExamScheduleEditProcess: false,

    allowKohaRestriction: false,

    // only inquiry prospect add course side modal
    allowStudentAgreement: false,

    // allow batchIndex field in components -> batch (currently allow for ijse)
    allowBatchIndex: false,

    // allow search student by cb in inquiry prospect section
    allowSameCBRegistration: true,

    // allow pending qualification
    allowPendingQualifications: true,

    // allow student limit field in component -> new batch modal
    allowStudentLimit: true,

    // allow study mode in course and batch modal
    allowStudyMode: false,

    //self declaration access to counsellor (false only for apiit)
    allowSelfDeclaration: true,

    // non-develop user roles hide in system
    allowNonDevUserRoles: false,

    newInquiryMismatchWarning: true,

    // showing terms and condition tick only for amrac
    allowTermsAndCondiInStudentPayment: true,

    // only apiit can't edit inquiry date
    allowInquiryDateEditable: true,
    // enabled this requested by rajiv told by sahan wickramasinghe

    //this is true only for amrac (told by sahan wickramasinghe)
    allowAptitudeTestForQualification: true,

    //this currently allow for only apiit and told by chamidi requested by apiit (2023-10-10)
    allowRegPaymentLessThanTotalDue: false,

    // component courses  course modal minimun elective field hide
    allowedCoursesMinimumElective: false,

    //resend offer letter access to counsellor (false only for apiit)
    allowResendOfferLetter: true,

    // Currently only allow for apiit
    allowInquiryToCb: true,

    // Currently only allow for apiit
    acceptanceLetter: false,

    // Currently only allow for apiit
    degreeStatusWithParentValidation: true,

    // Currently only allow for apiit
    batchTransferNotifyFinance: false,

    // Currently only allow for apiit
    paymentPlanChangeAfterNotifyStudent: false,

    // Currently only allow for amrak
    allowHaaRoleForInstituteEmailEditable: true,

    //Currently only false for cinec
    offerLetterSharedAfterSendRegLink: true,

    //Currently only false for cinec
    offerLetterTypes: true,

    //Currently only allow for cinec
    venueEstimatedCost: false,

    //Currently only allow for apiit
    allowBatchCreateKohaLibraryFields: false,

    // Currently only true for amrak (IT Manager --> Student Master Profile)
    allowSendMoodleLoginDetails: true

}

export const quickAction = {
    moodle: false,
    office365: false,
    externalInquiry: true,
    library: false
}

export const moodleAccessRole = [
    config.itAManagerRole, config.hosRole, config.studentRole, config.lecturer, config.haaRole,
    config.aaRole, config.maaRole
]

export const office365AccessRole = [
    config.itAManagerRole, config.hosRole, config.studentRole, config.lecturer, config.haaRole,
    config.aaRole, config.maaRole, config.counsellorRole, config.hocRole, config.hofRole, config.feRole,
    config.fmRole
]

export const assignBatchToStudentsAccessRole = [config.counsellorRole, config.hocRole]

export const externalInquiryAccessRole = [config.itAManagerRole, config.counsellorRole, config.hocRole]

export const libraryAccessRole = [config.studentRole, config.lecturer, config.haaRole, config.aaRole, config.maaRole]

export const qualification_list = [
    {label: 'G.C.E O/L', value: 'G.C.E O/L'},
    {label: 'G.C.E A/L', value: 'G.C.E A/L'},
    {label: 'GCSE O/L', value: 'GCSE O/L'},
    {label: 'GCSE A/L', value: 'GCSE A/L'},
    {label: 'Foundation', value: 'Foundation'},
    {label: 'L4 - 1', value: 'L4 - 1'},
    {label: 'L5 - 2', value: 'L5 - 2'},
    {label: 'L6 - 3', value: 'L6 - 3'},
    {label: 'L7 - PG Diploma', value: 'L7 - PG Diploma'},
    {label: 'HND', value: 'HND'},
    {label: 'ACCA', value: 'ACCA'},
    {label: 'CIMA', value: 'CIMA'},
    {label: 'CIM', value: 'CIM'},
    {label: 'AAT', value: 'AAT'},
    {label: 'Attorneys', value: 'Attorneys'},
    // below type is only valid for amrac
    {label: 'Aptitude Test + Interview', value: 'Aptitude Test + Interview'},
    {label: 'Other', value: 'Other'}
]

export const inquiryDateAccessRole = [config.hocRole, config.counsellorRole]

// add HOC only for APIIT, add HOC and Counselor for other universities
export const SMPSendOfferLetterButtonAccessRole = [config.hocRole, config.counsellorRole]

export const allowAccountStatementRole = [config.hofRole, config.feRole, config.fmRole]

// in apiit only hoc can resend OL, in others both counsellor and hoc can resend OL (confirmed by chamidi)
export const allowResendOfferLetterRole = [config.hocRole, config.counsellorRole]